import React from 'react';
//import PropTypes from 'prop-types';
import { TextField } from 'rmwc/TextField';
import { FormField } from 'rmwc/FormField';
import { DateSelector } from './DateSelector';
import { TimeSelector } from './TimeSelector';
import moment from 'moment';

export class DateTimeRange extends React.Component {
  constructor(props) {
    super(props);

    /**/
    const startDateTime = this.props.startDateTime;
    const stopDateTime = this.props.stopDateTime?this.props.stopDateTime:new Date(moment(startDateTime).add(1, 'h'))
    const dateFormat = "D MMM, YYYY";
    const timeFormat = "h:mm a";
    this.state = {
      startDateTime: startDateTime,
      stopDateTime: stopDateTime,
      startDateStr: moment(startDateTime).format("D MMM, YYYY"),
      startTimeStr: moment(startDateTime).format("h:mm a"),
      stopTimeStr: moment(stopDateTime).format("h:mm a"),
      dateFormat:dateFormat,
      timeFormat:timeFormat
    }
    this._updateStartDateTime = this._updateStartDateTime.bind(this);
    this._updateStopDateTime = this._updateStopDateTime.bind(this);
    this._toDateTime = this._toDateTime.bind(this);
    //this._initState = this._initState.bind(this);
  }

  _validDateTime(date, time) {
    return ((moment(date, "D MMM, YYYY", true).isValid()) && (moment(time, "h:mm a", true).isValid()))?true:false;
  }

  _toDateTime(date, time) {
    return moment(moment(date, this.state.dateFormat).format(this.state.dateFormat) + ' ' + time, "D MMM, YYYY h:mm a", true);
  }

  _getDate(dateTime) {
    return moment(dateTime).format("D MMM, YYYY");
  }

  _getTime(dateTime) {
    return moment(dateTime).format("h:mm a");
  }

  _updateStartDateTime(date, time) {
    if (this._validDateTime(date, time)) {
      var newStartDateTime = this._toDateTime(date, time);
      //console.log(newStartDateTime);
      var stopTime = this._getTime(this.state.stopDateTime);
      var newStopDateTime = this._toDateTime(date, stopTime);
      if (newStartDateTime>newStopDateTime) {
        newStopDateTime = this._toDateTime(date, time).add(1, 'h');
      }

      this.props.onChange({target:{id:"startDate", value:newStartDateTime.toDate()}});
      this.props.onChange({target:{id:"stopDate", value:newStopDateTime.toDate()}});
    }
  }

  _updateStopDateTime(date, time) {
    if (this._validDateTime(date, time)) {
      var newStopDateTime = this._toDateTime(date, time);
      this.props.onChange({target:{id:"stopDate", value:new Date(newStopDateTime)}});
    }
  }

  handleStartDateChange = val => {
    this.setState({startDateStr:val})
    this._updateStartDateTime(val, this.state.startTimeStr);
  }

  handleStartTimeChange = val => {
    this.setState({startTimeStr:val});
    this._updateStartDateTime(this.state.startDateStr, val);
  }

  handleStopTimeChange = val => {
    this.setState({stopTimeStr:val});
    this._updateStopDateTime(this.state.startDateStr, val);
  }

  render() {
    return (
      <FormField>
        <DateSelector
          date={this.state.startDateStr}
          onChange={this.handleStartDateChange}
        />
        <TimeSelector
          label="Form"
          time={this.state.startTimeStr}
          onChange={this.handleStartTimeChange}
        />
        <TextField style={{width:"10px"}} disabled value="-" readOnly/>
        <TimeSelector
          label="To"
          time={this.state.stopTimeStr}
          onChange={this.handleStopTimeChange}
        />
      </FormField>
    )
  }
}

/*
_adjustStopDate(startDate) {
  if (startDate >= this.props.stopDate) {
    console.log("new stop date")
    var newStopDate = new Date(
                            startDate.getFullYear(),
                            startDate.getMonth(),
                            startDate.getDate(),
                            this.props.stopDate.getHours(),
                            this.props.stopDate.getMinutes());
    if (startDate>=newStopDate) {
      newStopDate = new Date(
                              startDate.getFullYear(),
                              startDate.getMonth(),
                              startDate.getDate(),
                              startDate.getHours() + 1,
                              startDate.getMinutes());
    }
    var e = {
      target: {
        id:"stopDate",
        value:newStopDate
      }
    }
    this.props.onChange(e)
  }
}

_adustStartDate() {

}

*/



// WEBPACK FOOTER //
// ./src/components/DateTimeRange.js